// src/pages/AccountsDashboard.jsx
import React, { useState, useCallback, useEffect, useMemo } from "react";
import axios from "axios";
import AppConst from "../apis/appconst";
import AccountsReport from "../comps/AccountsReport";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Select from "react-select";


const pad = (n) => String(n).padStart(2, "0");
const getTodayYMD = () => {
  const d = new Date(); return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
};
const getNowHHMM = () => {
  const d = new Date(); return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export default function AccountsDashboard() {
  const [filters, setFilters] = useState({
    from: getTodayYMD(),
    to: getTodayYMD(),
    fromTime: "00:00",
    // toTime: getNowHHMM(),
    toTime: "23:59", 
    userId: "",
    paymentType: "All"
  });

  const [selectedDepartments, setSelectedDepartments] = useState([
    "lab",
    "opd",
    "ipd",
    
    "emergency"
  ]);

const [labAccounts, setLabAccounts] = useState(null);


  const departmentOptions = [
    { value: "lab", label: "Lab" },
    { value: "opd", label: "OPD" },
    { value: "ipd", label: "IPD" },
    { value: "pharmacy", label: "Pharmacy" },
    { value: "emergency", label: "Emergency" }
  ];
  const [labTotals, setLabTotals] = useState({ total:0, paid:0, due:0, rows:0, cash:0, card:0, online:0, discount:0 });
  const [opdTotals, setOpdTotals] = useState({
    total:0, paid:0, due:0, rows:0, cash:0, card:0, online:0, discount:0,
    opd_doctor_fees: 0, opd_reg_fees: 0
  });
  const [ipdAdmittedTotals, setIpdAdmittedTotals] = useState(null);
  const [ipdDischargedTotals, setIpdDischargedTotals] = useState(null);
  const [emergencyTotals, setEmergencyTotals] = useState({ 
    total: 0, paid: 0, due: 0, rows: 0, cash: 0, card: 0, online: 0, discount: 0, extra: {} 
  });
  const [ipdTotals, setIpdTotals] = useState({
    sum_reg_charges: 0, reg_charges_due: 0, reg_paid: 0, sum_ipd_bill: 0,
    totalAmount: 0, sum_paid: 0, sum_due: 0, count: 0,
    cash: 0, card: 0, online: 0, total: 0, paid: 0, due: 0, rows: 0, _raw: {}
  });
  const [pharmaTotals, setPharmaTotals] = useState({ total:0, paid:0, due:0, rows:0, cash:0, card:0, online:0, discount:0 });
  const toNum = (v) => {
    if (v === undefined || v === null || v === '') return 0;
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };
  const [ipdAdvanceTotals, setIpdAdvanceTotals] = useState({
    total: 0,
    cash: 0,
    card: 0,
    online: 0,
    rows: 0,
    records: []
  });

  

  




  const [ipdDischargeTotals, setIpdDischargeTotals] = useState({
    sum_paid: 0,
    cash: 0,
    card: 0,
    online: 0
  });
  
  const [ipdDischargeTransactions, setIpdDischargeTransactions] = useState([]);
  
  // ✅ NEW: Expenses state
  const [expensesTotals, setExpensesTotals] = useState({ 
    totalExpenses: 0, 
    expensesCount: 0, 
    expensesList: [] 
  });
  const [expensesLoading, setExpensesLoading] = useState(false);



  const [ipdReturnTotals, setIpdReturnTotals] = useState({
    total_returns: 0,
    total_cash: 0,
    total_card: 0,
    total_online: 0,
    total_lab_paid: 0,
    total_pharmacy_paid: 0,
    return_count: 0,
    records: []
  });
  const [ipdReturnLoading, setIpdReturnLoading] = useState(false);



  const ipdCashFinal =
  toNum(ipdTotals.cash) + toNum(ipdAdvanceTotals.cash);

const ipdCardFinal =
  toNum(ipdTotals.card) + toNum(ipdAdvanceTotals.card);

const ipdOnlineFinal =
  toNum(ipdTotals.online) + toNum(ipdAdvanceTotals.online);

  
  
  // 1️⃣ Registration + Advance
const regPlusAdvance =
toNum(ipdTotals.reg_paid) + toNum(ipdAdvanceTotals.total);


// ✅ 1️⃣ Advance collected (real money)
const ipdAdvanceCollected = toNum(ipdAdvanceTotals.total);

// ✅ 2️⃣ IPD bill paid (includes admitted + discharged + reg)
const ipdBillPaid = toNum(ipdTotals.sum_paid);

// ✅ 3️⃣ TOTAL IPD COLLECTION (real cash)
const ipdTotalPaid = ipdAdvanceCollected + ipdBillPaid;

 
  // ✅ Deduplicate records by unique ID
  const deduplicateRecords = (records, idField = 'id') => {
    if (!Array.isArray(records)) return records;
    
    const seen = new Set();
    return records.filter(record => {
      const id = record[idField] || record.med_bill_id || record.id;
      if (seen.has(id)) {
        console.warn(`Duplicate record found with ${idField}:`, id);
        return false;
      }
      seen.add(id);
      return true;
    });
  };

  const normalizeIpdTotals = (t = {}) => {
    const sum_reg_charges = toNum(t.sum_reg_charges ?? t.sum_reg ?? t.reg_charges ?? t.reg ?? t.total_reg ?? t.reg_total ?? 0);
    const sum_ipd_bill    = toNum(t.sum_ipd_bill ?? t.sum_ipd ?? t.ipd_total ?? t.ipd_bill_total ?? t.sum_bill ?? 0);
    const sum_paid        = toNum(t.sum_paid ?? t.sum_total_paid ?? t.paid ?? t.total_paid ?? t.paid_amount ?? 0);
    const sum_due         = toNum(t.sum_due ?? t.sum_total_due ?? t.due ?? t.total_due ?? 0);
    const count           = Math.max(0, Math.trunc(toNum(t.count ?? t.rows ?? t.records_count ?? t.total_rows ?? 0)));

    const firstMatch = (keys) => {
      for (let k of keys) {
        if (Object.prototype.hasOwnProperty.call(t, k)) return toNum(t[k]);
      }
      return 0;
    };
    const cashKeys = ['sum_paid_cash','sum_cash','total_cash','paid_cash','paidCash','cash','total_cash_paid'];
    const cardKeys = ['sum_paid_card','sum_card','total_card','paid_card','paidCard','card','total_card_paid'];
    const onlineKeys = ['sum_paid_online','sum_online','total_online','paid_online','paidOnline','online','total_online_paid'];

    const cash  = firstMatch(cashKeys);
    const card  = firstMatch(cardKeys);
    const online = firstMatch(onlineKeys);

    const reg_charges_due_keylist = ['reg_charges_due','sum_reg_due','sum_reg_charges_due','reg_due','reg_charges_outstanding'];
    let reg_charges_due = null;
    for (let k of reg_charges_due_keylist) {
      if (Object.prototype.hasOwnProperty.call(t, k)) { reg_charges_due = toNum(t[k]); break; }
    }
    if (reg_charges_due === null) {
      reg_charges_due = sum_due && sum_ipd_bill ? Math.max(0, sum_due - sum_ipd_bill) : 0;
    }

    const reg_paid = Math.max(0, sum_reg_charges - reg_charges_due);
    const totalAmount = sum_reg_charges + sum_ipd_bill;

    return {
      sum_reg_charges, reg_charges_due, reg_paid, sum_ipd_bill, totalAmount,
      sum_paid, sum_due, count, cash, card, online,
      total: totalAmount, paid: sum_paid, due: sum_due, rows: count, _raw: t
    };
  };

  const handleIpdAdmitted = (t = {}) => {
    const normalized = normalizeIpdTotals(t);
    setIpdAdmittedTotals(normalized);
  };

  const handleIpdDischarged = (t = {}) => {
    const normalized = normalizeIpdTotals(t);
    setIpdDischargedTotals(normalized);
    
    // ✅ Capture transactions from API response
    if (Array.isArray(t.transactions)) {
      setIpdDischargeTransactions(t.transactions);
    }
  };

  const fetchIpdReturnAccounts = useCallback(async () => {
    setIpdReturnLoading(true);
    try {
      const fd = new FormData();
      fd.append('from', `${filters.from} ${filters.fromTime || '00:00'}:00`);
      fd.append('to', `${filters.to} ${filters.toTime || '23:59'}:59`);
   
      const res = await axios.post(
        `${AppConst.BASE_URL}${AppConst.getIpdReturnAccountsUrl}`,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
   
      if (res?.data?.status) {
        setIpdReturnTotals({
          ...res.data.totals,
          records: res.data.records || []
        });
      } else {
        setIpdReturnTotals({
          total_returns: 0, total_cash: 0, total_card: 0, total_online: 0,
          total_lab_paid: 0, total_pharmacy_paid: 0, return_count: 0, records: []
        });
      }
    } catch (err) {
      console.error('fetchIpdReturnAccounts error', err);
      setIpdReturnTotals({
        total_returns: 0, total_cash: 0, total_card: 0, total_online: 0,
        total_lab_paid: 0, total_pharmacy_paid: 0, return_count: 0, records: []
      });
    } finally {
      setIpdReturnLoading(false);
    }
  }, [filters]);
   
   
  // ============================================================
  // STEP 3: ADD useEffect to fetch on filter change
  // ============================================================
   
  useEffect(() => {
    if (selectedDepartments.includes("ipd")) {
      fetchIpdReturnAccounts();
    }
  }, [filters.from, filters.to, filters.fromTime, filters.toTime, fetchIpdReturnAccounts, selectedDepartments]);


  const fetchIpdDischargeAccounts = async () => {
    const fd = new FormData();
    fd.append("from", `${filters.from} ${filters.fromTime}:00`);
    fd.append("to", `${filters.to} ${filters.toTime}:59`);
  
    const res = await axios.post(
      `${AppConst.BASE_URL}${AppConst.getIpdDischargedUrl}`,
      fd
    );
    
    if (res.data?.status) {
      setIpdDischargeTotals(res.data.totals);
      setIpdDischargeTransactions(res.data.transactions || []);
    }
  };

  
  useEffect(() => {
    fetchIpdDischargeAccounts();
  }, [filters]);
  


  // ✅ Fetch Expenses
  const fetchExpenses = useCallback(async (currentFilters = filters) => {
    setExpensesLoading(true);
    try {
      const fd = new FormData();
      fd.append('page_no', 'none');
      
      // ✅ Use date range filters
      if (currentFilters.from) fd.append('from', `${currentFilters.from} ${currentFilters.fromTime || '00:00'}:00`);
      if (currentFilters.to) fd.append('to', `${currentFilters.to} ${currentFilters.toTime || '23:59'}:59`);

      const url = `${AppConst.BASE_URL}${AppConst.getExpensesListUrl || 'get_expenses_list'}`;
      const res = await axios.post(url, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (res?.data?.status && Array.isArray(res.data.records)) {
        const records = res.data.records;
        const totalExpenses = records.reduce((sum, r) => sum + (parseFloat(r.amount) || 0), 0);
        
        setExpensesTotals({
          totalExpenses: totalExpenses,
          expensesCount: records.length,
          expensesList: records
        });
      } else {
        setExpensesTotals({ totalExpenses: 0, expensesCount: 0, expensesList: [] });
      }
    } catch (err) {
      console.error('fetchExpenses error', err);
      setExpensesTotals({ totalExpenses: 0, expensesCount: 0, expensesList: [] });
    } finally {
      setExpensesLoading(false);
    }
  }, []);



  
  useEffect(() => {
    const a = ipdAdmittedTotals || {};
    const d = ipdDischargeTotals || {};
  
    const merged = {
      sum_reg_charges: toNum(a.sum_reg_charges) + toNum(d.sum_reg_charges),
      reg_charges_due: toNum(a.reg_charges_due) + toNum(d.reg_charges_due),
      reg_paid: toNum(a.reg_paid) + toNum(d.reg_paid),
      sum_ipd_bill: toNum(a.sum_ipd_bill) + toNum(d.sum_ipd_bill),
      totalAmount: toNum(a.totalAmount) + toNum(d.totalAmount),
      sum_paid: toNum(a.sum_paid) + toNum(d.sum_paid),
      sum_due: toNum(a.sum_due) + toNum(d.sum_due),
      count: Math.trunc(toNum(a.count) + toNum(d.count)),
      cash: toNum(a.cash) + toNum(d.cash),
      card: toNum(a.card) + toNum(d.card),
      online: toNum(a.online) + toNum(d.online),
      rows: Math.trunc(toNum(a.rows) + toNum(d.rows)),
      _raw: { admitted: a, discharged: d }
    };
  
    setIpdTotals(merged);
  }, [ipdAdmittedTotals, ipdDischargeTotals]);
  
  const setTotalsCallback = useCallback((setter) => (t) => setter(t), []);

  // ✅ Pharmacy-specific wrapper to deduplicate before calculating totals
  const setPharmaTotalsWithDedup = useCallback((totalsData) => {
    console.log("📦 Pharmacy raw totals received:", totalsData);
    
    // If totalsData has a records array, deduplicate it
    if (totalsData.records && Array.isArray(totalsData.records)) {
      const originalCount = totalsData.records.length;
      totalsData.records = deduplicateRecords(totalsData.records, 'med_bill_id');
      const dedupCount = totalsData.records.length;
      
      if (originalCount !== dedupCount) {
        console.warn(`⚠️ Pharmacy duplicates removed: ${originalCount} → ${dedupCount}`);
        
        // Recalculate totals after deduplication
        const recalculated = {
          total: 0,
          paid: 0,
          due: 0,
          rows: dedupCount,
          cash: 0,
          card: 0,
          online: 0,
          discount: 0
        };
        
        totalsData.records.forEach(record => {
          recalculated.total += toNum(record.med_bill_final_amt);
          recalculated.paid += toNum(record.med_bill_paid);
          recalculated.due += toNum(record.med_bill_due);
          recalculated.discount += toNum(record.med_bill_discount_amt);
          
          // Sum up payment modes from payment history if available
          if (record.payment_history && Array.isArray(record.payment_history)) {
            record.payment_history.forEach(payment => {
              const mode = String(payment.payment_mode || '').toLowerCase();
              const amount = toNum(payment.payment_amount);
              if (mode === 'cash') recalculated.cash += amount;
              else if (mode === 'card') recalculated.card += amount;
              else if (mode === 'online') recalculated.online += amount;
            });
          }
        });
        
        console.log("✅ Pharmacy recalculated totals:", recalculated);
        setPharmaTotals(recalculated);
        return;
      }
    }
    
    // If no deduplication needed, use original data
    setPharmaTotals(totalsData);
  }, []);

  

  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);

// ✅ Add to state declarations (around line 40)
// ✅ NEW - Complete structure
const [pharmacyPaymentHistory, setPharmacyPaymentHistory] = useState({
  totals: { 
    total_amount: 0, 
    total_cash: 0, 
    total_card: 0, 
    total_online: 0, 
    total_patients: 0,
    total_returns: 0,
    final_collection: 0,
    payment_count: 0
  },
  payments: [],
  daily_breakdown: []
});
const [pharmacyPaymentLoading, setPharmacyPaymentLoading] = useState(false);

// ✅ Add fetch function (around line 200)
const fetchPharmacyPaymentHistory = useCallback(async () => {
  setPharmacyPaymentLoading(true);
  try {
    const fd = new FormData();
    
    // if (filters.from) fd.append('from_date', filters.from);
    // if (filters.to) fd.append('to_date', filters.to);

    if (filters.from) {
      fd.append('from_date', filters.from);
      fd.append('from_time', filters.fromTime || '00:00');
    }
    
    if (filters.to) {
      fd.append('to_date', filters.to);
      fd.append('to_time', filters.toTime || '23:59');
    }
    
    if (filters.userId) fd.append('user_id', filters.userId);
    if (filters.paymentType && filters.paymentType !== 'All') {
      fd.append('payment_mode', filters.paymentType);
    }

    const url = `${AppConst.BASE_URL}${AppConst.getPharmacyAccountsUrl}`;
    const res = await axios.post(url, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (res?.data?.status) {
      setPharmacyPaymentHistory(res.data);
    
      setPharmaTotals({
        total: Number(res.data.totals.total_amount || 0),
    
        // ✅ Paid = after returns
        paid: Number(res.data.totals.final_collection || 0),
    
        due: 0,
        rows: Number(res.data.totals.total_patients || 0),
    
        // ✅ RAW payment modes (NO adjustment)
        cash: Number(res.data.totals.total_cash || 0),
        card: Number(res.data.totals.total_card || 0),
        online: Number(res.data.totals.total_online || 0),
    
        discount: 0,
    
        // keep returns separate
        returnAmount: Number(res.data.totals.total_returns || 0)
      });
    }
     else {
      const emptyState = {
        totals: { 
          total_amount: 0, 
          total_cash: 0, 
          total_card: 0, 
          total_online: 0, 
          total_patients: 0,
          total_returns: 0,
          final_collection: 0,
          payment_count: 0
        },
        payments: [],
        daily_breakdown: []
      };
      setPharmacyPaymentHistory(emptyState);
      
      setPharmaTotals({
        total: 0, paid: 0, due: 0, rows: 0,
        cash: 0, card: 0, online: 0, discount: 0, returnAmount: 0
      });
    }
  } catch (err) {
    console.error('fetchPharmacyPaymentHistory error', err);
    
    const emptyState = {
      totals: { 
        total_amount: 0, 
        total_cash: 0, 
        total_card: 0, 
        total_online: 0, 
        total_patients: 0,
        total_returns: 0,
        final_collection: 0,
        payment_count: 0
      },
      payments: [],
      daily_breakdown: []
    };
    setPharmacyPaymentHistory(emptyState);
    
    setPharmaTotals({
      total: 0, paid: 0, due: 0, rows: 0,
      cash: 0, card: 0, online: 0, discount: 0, returnAmount: 0
    });
  } finally {
    setPharmacyPaymentLoading(false);
  }
}, [filters]);

// ✅ Add useEffect to fetch on filter change
// ✅ CORRECT - Remove hasDept from dependencies, check selectedDepartments directly
useEffect(() => {
  if (selectedDepartments.includes("pharmacy")) {
    fetchPharmacyPaymentHistory();
  }
}, [filters.from, filters.to, filters.userId, filters.paymentType, fetchPharmacyPaymentHistory, selectedDepartments]);

  const fetchIpdAdvanceAccounts = useCallback(async () => {
    try {
      const fd = new FormData();
  
      fd.append('from', `${filters.from} ${filters.fromTime || '00:00'}:00`);
      fd.append('to', `${filters.to} ${filters.toTime || '23:59'}:59`);
  
      const res = await axios.post(
        `${AppConst.BASE_URL}${AppConst.getIpdAdvancePaymentsUrl}`,
        fd
      );
  
      if (res?.data?.status) {
        setIpdAdvanceTotals({
          total: Number(res.data.total_advance || 0),
          cash: Number(res.data.cash || 0),
          card: Number(res.data.card || 0),
          online: Number(res.data.online || 0),
          rows: res.data.records.length,
          records: res.data.records
        });
      }
    } catch (e) {
      console.error(e);
    }
  }, [filters]);
  

  useEffect(() => {
    fetchIpdAdvanceAccounts();
  }, [fetchIpdAdvanceAccounts]);
    


  const detectLoggedIn = () => {
    try {
      const raw = localStorage.getItem("currentUser") || localStorage.getItem("user");
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed) return null;
      const id = parsed.user_id ?? parsed.id ?? parsed.uid ?? parsed.userId ?? null;
      const name = parsed.fname || parsed.name || parsed.user_display || parsed.username || "";
      if (id) return { id: String(id), name: String(name) };
    } catch (e) {}
    return null;
  };

  useEffect(() => {
    const loadUsers = async () => {
      setUsersLoading(true);
      try {
        const fd = new FormData();
        fd.append("type", "user");
        fd.append("page_no", "none");
        const url = `${AppConst.BASE_URL.replace(/\/+$/,"")}/${String(AppConst.getUserListUrl).replace(/^\/+/,"")}`;
        const res = await axios.post(url, fd);
        const d = res?.data ?? {};
        const items = Array.isArray(d.records) ? d.records : Array.isArray(d.data) ? d.data : (Array.isArray(d) ? d : []);
        const normalized = items.map(u => ({ id: u.user_id ?? u.id ?? u.uid ?? null, name: u.fname || u.name || u.user_display || u.username || `User#${u.user_id}` }));
        setUsers(normalized.filter(x => x.id !== null));
        const logged = detectLoggedIn();
        if (logged) setFilters(prev => ({ ...prev, userId: prev.userId || String(logged.id) }));
      } catch (err) {
        console.error("AccountsDashboard loadUsers error", err);
      } finally {
        setUsersLoading(false);
      }
    };
    loadUsers();
    // eslint-disable-next-line
  }, []);

  // ✅ Fetch expenses when filters change
  useEffect(() => {
    fetchExpenses(filters);
  }, [filters.from, filters.to, filters.fromTime, filters.toTime, fetchExpenses]);

  const onFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const fullUrl = (keyOrRel) => {
    const rel = AppConst[keyOrRel] || keyOrRel;
    if (!rel) return undefined;
    return `${AppConst.BASE_URL.replace(/\/+$/,"")}/${String(rel).replace(/^\/+/,"")}`;
  };
  const hasDept = (d) => selectedDepartments.includes(d);

  const baseFetchParams = useMemo(() => {
    const p = {
      page_no: "none",
      from: filters.from || undefined,
      to: filters.to || undefined,
      from_time: filters.fromTime || undefined,
      to_time: filters.toTime || undefined,
      ipd_user: filters.userId || undefined,
      userId: filters.userId || undefined,
      payment_type: (filters.paymentType && filters.paymentType !== "All") ? filters.paymentType : undefined
    };
    const out = {};
    Object.entries(p).forEach(([k,v]) => { if (v !== undefined && v !== null && v !== "") out[k] = v; });
    return out;
  }, [filters]);

  const combined = useMemo(() => {
    let total = 0, paid = 0, due = 0, cash = 0, card = 0, online = 0, rows = 0;
  
    if (hasDept("lab")) {
      total += toNum(labTotals.total);
      paid  += toNum(labTotals.paid);
      due   += toNum(labTotals.due);
      cash  += toNum(labTotals.cash);
      card  += toNum(labTotals.card);
      online+= toNum(labTotals.online);
      rows  += toNum(labTotals.rows);
    }
  
    if (hasDept("opd")) {
      const opdBaseTotal = toNum(opdTotals.total);
      const opdProcedureBills = toNum(opdTotals.extra?.["Procedure Bills"] ?? 0);
      
      total += opdBaseTotal + opdProcedureBills;
      paid  += toNum(opdTotals.paid) + opdProcedureBills;
      due   += toNum(opdTotals.due);
      
      // ✅ FIX: opdTotals.cash/card/online already include procedure bill modes
      cash  += toNum(opdTotals.cash);
      card  += toNum(opdTotals.card);
      online+= toNum(opdTotals.online);
      
      rows  += toNum(opdTotals.rows);
  }
    
    if (hasDept("emergency")) {
      const eCash   = toNum(emergencyTotals.cash);
      const eCard   = toNum(emergencyTotals.card);
      const eOnline = toNum(emergencyTotals.online);
    
      const emergencyPaid = eCash + eCard + eOnline;
    
      total += emergencyPaid;   // emergency has no due concept
      paid  += emergencyPaid;
      due   += 0;
    
      cash  += eCash;
      card  += eCard;
      online+= eOnline;
    
      rows  += toNum(emergencyTotals.rows);
    }
    
    
    
    
  
    if (hasDept("ipd")) {
      total += toNum(ipdTotals.sum_reg_charges) + toNum(ipdTotals.sum_ipd_bill);
      paid  += toNum(ipdTotals.sum_paid) + toNum(ipdAdvanceTotals.total);
      due   += toNum(ipdTotals.sum_due);
   
      cash  += toNum(ipdTotals.cash) + toNum(ipdAdvanceTotals.cash);
      card  += toNum(ipdTotals.card) + toNum(ipdAdvanceTotals.card);
      online+= toNum(ipdTotals.online) + toNum(ipdAdvanceTotals.online);
   
      rows  += toNum(ipdTotals.rows || ipdTotals.count);
   
      // ✅ DEDUCT IPD RETURNS from paid totals
      const ipdReturns = toNum(ipdReturnTotals.total_returns);
      if (ipdReturns > 0) {
        paid -= ipdReturns;
        cash -= toNum(ipdReturnTotals.total_cash);
        card -= toNum(ipdReturnTotals.total_card);
        online -= toNum(ipdReturnTotals.total_online);
      }
    }
    
  
    if (hasDept("pharmacy")) {
      total += toNum(pharmaTotals.total);
      paid  += toNum(pharmaTotals.paid);
      due   += toNum(pharmaTotals.due);
      cash  += toNum(pharmaTotals.cash);
      card  += toNum(pharmaTotals.card);
      online+= toNum(pharmaTotals.online);
      rows  += toNum(pharmaTotals.rows);
    }
  
    return { total, paid, due, cash, card, online, rows };
  }, [
    selectedDepartments,
    labTotals,
    opdTotals,
    emergencyTotals,
    ipdTotals,
    ipdAdvanceTotals,
    ipdReturnTotals,    // ← ADD THIS
    pharmaTotals
  ]);
  
  
  const logged = detectLoggedIn();

  const handleIpdTotals = (t = {}) => {
    const toNum = (v) => {
      if (v === undefined || v === null || v === '') return 0;
      const n = Number(v);
      return isNaN(n) ? 0 : n;
    };
  
    const sum_reg_charges = toNum(t.sum_reg_charges ?? t.sum_reg ?? t.reg_charges ?? t.reg ?? t.total_reg ?? t.reg_total ?? 0);
    const sum_ipd_bill    = toNum(t.sum_ipd_bill ?? t.sum_ipd ?? t.ipd_total ?? t.ipd_bill_total ?? t.sum_bill ?? 0);
    const sum_paid        = toNum(t.sum_paid ?? t.sum_total_paid ?? t.paid ?? t.total_paid ?? t.paid_amount ?? 0);
    const sum_due         = toNum(t.sum_due ?? t.sum_total_due ?? t.due ?? t.total_due ?? 0);
    const count           = Math.max(0, Math.trunc(toNum(t.count ?? t.rows ?? t.records_count ?? t.total_rows ?? 0)));
  
    const cashKeys = ['sum_paid_cash','sum_cash','total_cash','ipd_payment_history_cash','ipd_payment_history_paid_cash','paid_cash','paidCash','cash'];
    const cardKeys = ['sum_paid_card','sum_card','total_card','ipd_payment_history_card','ipd_payment_history_paid_card','paid_card','paidCard','card'];
    const onlineKeys = ['sum_paid_online','sum_online','total_online','ipd_payment_history_online','ipd_payment_history_paid_online','paid_online','paidOnline','online'];
  
    const firstMatch = (keys) => {
      for (let k of keys) {
        if (Object.prototype.hasOwnProperty.call(t, k)) return toNum(t[k]);
      }
      return 0;
    };
  
    const cash  = firstMatch(cashKeys);
    const card  = firstMatch(cardKeys);
    const online = firstMatch(onlineKeys);
  
    let reg_charges_due = null;
    const explicitRegDueKeys = ['reg_charges_due','sum_reg_due','sum_reg_charges_due','reg_due','reg_charges_outstanding'];
    for (let k of explicitRegDueKeys) {
      if (Object.prototype.hasOwnProperty.call(t, k)) { reg_charges_due = toNum(t[k]); break; }
    }
    if (reg_charges_due === null) {
      if (sum_due && sum_ipd_bill) {
        reg_charges_due = Math.max(0, sum_due - sum_ipd_bill);
      } else {
        reg_charges_due = 0;
      }
    }
  
    const reg_paid = Math.max(0, sum_reg_charges - reg_charges_due);
    const totalAmount = sum_reg_charges + sum_ipd_bill;
  
    const normalized = {
      sum_reg_charges, reg_charges_due, reg_paid, sum_ipd_bill, totalAmount,
      sum_paid, sum_due, count, cash, card, online,
      total: totalAmount, paid: sum_paid, due: sum_due, rows: count, _raw: t
    };
  
    normalized.total_cash = normalized.cash;
    normalized.total_card = normalized.card;
    normalized.total_online = normalized.online;
  
    setIpdTotals(prev => ({ ...prev, ...normalized }));
  };
  const totalPatients =
  toNum(labTotals.rows) +
  toNum(opdTotals.rows) +
  toNum(emergencyTotals.rows) +
  toNum(ipdTotals.rows) +
  toNum(pharmaTotals.rows);

  // ✅ Export PDF with Expenses
  const exportSummaryWithAutoTable = () => {
    try {
      const doc = new jsPDF("p", "mm", "a4");
      const marginLeft = 14;
      const pageWidth = doc.internal.pageSize.getWidth();
      const usableWidth = pageWidth - marginLeft * 2;
  
      const now = new Date();
      const ts = now.toLocaleString();
  
      // Format selected filter range
      const fromDate = filters.from || "";
      const toDate   = filters.to   || "";
      const fromTime = filters.fromTime || "00:00";
      const toTime   = filters.toTime || "23:59";
      const rangeStr = (fromDate || toDate)
        ? `From: ${fromDate} ${fromTime}  —  To: ${toDate} ${toTime}`
        : `All dates`;
  
      // Title + meta
      doc.setFontSize(14);
      doc.text("Accounts Dashboard — Summary", marginLeft, 18);
      doc.setFontSize(10);
      doc.text(`Generated: ${ts}`, marginLeft, 24);
      doc.text(rangeStr, marginLeft, 30);
  
      // ✅ Calculate all totals
      const labTotal = Number(labTotals?.total ?? 0);
      const labPaid = Number(labTotals?.paid ?? 0);
      const labDue = Number(labTotals?.due ?? 0);
      
      // ✅ OPD: Include procedure bills
      const opdBaseTotal = Number(opdTotals?.total ?? 0);
      const opdBasePaid = Number(opdTotals?.paid ?? 0);
      const opdBaseDue = Number(opdTotals?.due ?? 0);
      const opdProcedureBills = Number(opdTotals?.extra?.["Procedure Bills"] ?? 0);
      const opdProcCash = Number(opdTotals?.extra?.["Procedure Bills Cash"] ?? 0);
      const opdProcCard = Number(opdTotals?.extra?.["Procedure Bills Card"] ?? 0);
      const opdProcOnline = Number(opdTotals?.extra?.["Procedure Bills Online"] ?? 0);
      const opdTotal = opdBaseTotal + opdProcedureBills;
      const opdPaid = opdBasePaid + opdProcedureBills;
      const opdDue = opdBaseDue;
  
      // ✅ Emergency: PAID ONLY
      const emergencyPaid = Number(emergencyTotals?.paid ?? 0);
      const emergencyTotal = emergencyPaid;
      const emergencyDue = 0;
  
      // IPD - Use same calculation as UI combined summary
      const ipdReg = Number(ipdTotals?.sum_reg_charges ?? 0);
      const ipdBill = Number(ipdTotals?.sum_ipd_bill ?? 0);
      const ipdCombined = ipdReg + ipdBill;
      const ipdPaid = Number(ipdTotals?.sum_paid ?? 0);
      const ipdDue = Number(ipdTotals?.sum_due ?? 0);
      const ipdAdvanceAmount = Number(ipdAdvanceTotals?.total ?? 0);
  
      // Pharmacy
      const pharmaTotal = Number(pharmaTotals?.total ?? 0);
      const pharmaPaid = Number(pharmaTotals?.paid ?? 0);
      const pharmaDue = Number(pharmaTotals?.due ?? 0);
      const pharmaReturns = Number(pharmaTotals?.returnAmount ?? 0);
  
      // ✅ Expenses
      const totalExpenses = Number(expensesTotals?.totalExpenses ?? 0);
      const expensesCount = Number(expensesTotals?.expensesCount ?? 0);
  
      // ✅ Grand Totals
      const grandTotal = labTotal + opdTotal + emergencyTotal + ipdCombined + pharmaTotal;
      const grandPaid = labPaid + opdPaid + emergencyPaid + ipdPaid + ipdAdvanceAmount + pharmaPaid;
      const grandDue = labDue + opdDue + emergencyDue + ipdDue + pharmaDue;
  
      // ✅ Payment breakdown - Include procedure bill payment modes
      const labCash = Number(labTotals?.cash ?? 0);
      const labCard = Number(labTotals?.card ?? 0);
      const labOnline = Number(labTotals?.online ?? 0);
  
      const opdCash = Number(opdTotals?.cash ?? 0) + opdProcCash;
      const opdCard = Number(opdTotals?.card ?? 0) + opdProcCard;
      const opdOnline = Number(opdTotals?.online ?? 0) + opdProcOnline;
  
      const emergencyCash = Number(emergencyTotals?.cash ?? 0);
      const emergencyCard = Number(emergencyTotals?.card ?? 0);
      const emergencyOnline = Number(emergencyTotals?.online ?? 0);
  
      const ipdReturnAmt = toNum(ipdReturnTotals?.total_returns ?? 0);
      const ipdCash = Number(ipdTotals?.cash ?? 0) + Number(ipdAdvanceTotals?.cash ?? 0) - toNum(ipdReturnTotals?.total_cash ?? 0);
      const ipdCard = Number(ipdTotals?.card ?? 0) + Number(ipdAdvanceTotals?.card ?? 0) - toNum(ipdReturnTotals?.total_card ?? 0);
      const ipdOnline = Number(ipdTotals?.online ?? 0) + Number(ipdAdvanceTotals?.online ?? 0) - toNum(ipdReturnTotals?.total_online ?? 0);
  
      const pharmaCash = Number(pharmaTotals?.cash ?? 0);
      const pharmaCard = Number(pharmaTotals?.card ?? 0);
      const pharmaOnline = Number(pharmaTotals?.online ?? 0);
  
      // ✅ Total payment modes
      const totalCash = labCash + opdCash + emergencyCash + ipdCash + pharmaCash;
      const totalCard = labCard + opdCard + emergencyCard + ipdCard + pharmaCard;
      const totalOnline = labOnline + opdOnline + emergencyOnline + ipdOnline + pharmaOnline;
  
      // ✅ Total Collection = Cash + Card + Online - Returns - Expenses
     // ✅ FIX: Use combined values (same as UI) instead of recalculating
     const totalCollected = toNum(combined.cash) + toNum(combined.card) + toNum(combined.online);
     const netCollection = totalCollected - pharmacyReturns - totalExpenses;
  
      // ✅ Patient counts
      const labPatients = toNum(labTotals?.rows);
      const opdPatients = toNum(opdTotals?.rows);
      const emergencyPatients = toNum(emergencyTotals?.rows);
      const ipdAdmittedPatients = toNum(ipdAdmittedTotals?.rows);
      const ipdDischargedPatients = toNum(ipdDischargedTotals?.rows);
      const pharmacyPatients = toNum(pharmaTotals?.rows);
  
      const totalPatients =
        labPatients +
        opdPatients +
        emergencyPatients +
        ipdAdmittedPatients +
        ipdDischargedPatients +
        pharmacyPatients;
  
      const rows = [
        [`Lab (Total) [Patients: ${labPatients}]`, labTotal.toFixed(2)],
        [`OPD — Base [Patients: ${opdPatients}]`, opdBaseTotal.toFixed(2)],
        [`OPD — Procedure Bills`, opdProcedureBills.toFixed(2)],
        [`OPD — Combined Total`, opdTotal.toFixed(2)],
        [`Emergency — (Paid Only) [Patients: ${emergencyPatients}]`, emergencyPaid.toFixed(2)],
        [`IPD Admitted [Patients: ${ipdAdmittedPatients}]`, toNum(ipdAdmittedTotals?.total).toFixed(2)],
        [`IPD Discharged [Patients: ${ipdDischargedPatients}]`, toNum(ipdDischargedTotals?.total).toFixed(2)],
        ["IPD Advance Collected", ipdAdvanceAmount.toFixed(2)],
        ["IPD — (Reg + IPD)", ipdCombined.toFixed(2)],
        [`Pharmacy (Total) [Patients: ${pharmacyPatients}]`, pharmaTotal.toFixed(2)],
        ...(ipdReturnAmt > 0 ? [[
          { content: `IPD RETURNS / REFUNDS (${ipdReturnTotals?.return_count || 0} returns)`, styles: { fillColor: [255, 220, 220], fontStyle: "bold" } },
          { content: `- ${ipdReturnAmt.toFixed(2)}`, styles: { fillColor: [255, 220, 220], fontStyle: "bold" } }
        ]] : []),
        ["", ""],
        [
          { content: "TOTAL PATIENTS", styles: { fontStyle: "bold" } },
          { content: totalPatients.toString(), styles: { fontStyle: "bold", halign: "right" } }
        ],
        [
          { content: "GRAND PAID AMOUNT", styles: { fillColor: [220,240,220], fontStyle: "bold" } },
          { content: grandPaid.toFixed(2), styles: { fillColor: [220,240,220], fontStyle: "bold" } }
        ],
        [
          { content: `TOTAL EXPENSES (${expensesCount} items)`, styles: { fillColor: [255,200,200], fontStyle: "bold" } },
          { content: totalExpenses.toFixed(2), styles: { fillColor: [255,200,200], fontStyle: "bold" } }
        ],
        ...(pharmaReturns > 0 ? [[
          { content: "PHARMACY RETURNS", styles: { fillColor: [255,220,220], fontStyle: "bold" } },
          { content: `- ${pharmaReturns.toFixed(2)}`, styles: { fillColor: [255,220,220], fontStyle: "bold" } }
        ]] : []),
        [
          { content: "NET COLLECTION (Paid - Returns - Expenses)", styles: { fillColor: [200,255,200], fontStyle: "bold" } },
          { content: netCollection.toFixed(2), styles: { fillColor: [200,255,200], fontStyle: "bold" } }
        ],
        ["", ""],
        [
          { content: "GRAND DUE AMOUNT", styles: { fillColor: [255,230,230], fontStyle: "bold" } },
          { content: grandDue.toFixed(2), styles: { fillColor: [255,230,230], fontStyle: "bold" } }
        ]
      ];
  
      // Add main totals table
      autoTable(doc, {
        startY: 36,
        theme: "grid",
        head: [["Item", "Amount (₹)"]],
        body: rows,
        styles: { fontSize: 9 },
        headStyles: { fillColor: [60, 130, 200], textColor: 255, halign: "center", fontSize: 10 },
        columnStyles: {
          0: { cellWidth: usableWidth * 0.65, halign: "left" },
          1: { cellWidth: usableWidth * 0.35, halign: "right", fontStyle: "bold" }
        },
        tableWidth: usableWidth,
      });
  
      // ✅ Payment breakdown table
      const afterY = doc.lastAutoTable.finalY + 10;
  
      const paymentRows = [
        ["Lab - Cash", labCash.toFixed(2)],
        ["Lab - Card", labCard.toFixed(2)],
        ["Lab - Online", labOnline.toFixed(2)],
        ["", ""],
        ["OPD - Cash (Base + Procedure)", opdCash.toFixed(2)],
        ["OPD - Card (Base + Procedure)", opdCard.toFixed(2)],
        ["OPD - Online (Base + Procedure)", opdOnline.toFixed(2)],
        ["", ""],
        ["Emergency - Cash", emergencyCash.toFixed(2)],
        ["Emergency - Card", emergencyCard.toFixed(2)],
        ["Emergency - Online", emergencyOnline.toFixed(2)],
        ["", ""],
        ["IPD - Cash (Bill + Advance - Returns)", ipdCash.toFixed(2)],
        ["IPD - Card (Bill + Advance - Returns)", ipdCard.toFixed(2)],
        ["IPD - Online (Bill + Advance - Returns)", ipdOnline.toFixed(2)],
        ...(ipdReturnAmt > 0 ? [["IPD - Returns Deducted", `- ${ipdReturnAmt.toFixed(2)}`]] : []),
        ["", ""],
        ["Pharmacy - Cash", pharmaCash.toFixed(2)],
        ["Pharmacy - Card", pharmaCard.toFixed(2)],
        ["Pharmacy - Online", pharmaOnline.toFixed(2)],
        ["", ""],
        [
          { content: "TOTAL CASH", styles: { fillColor: [230,255,230], fontStyle: "bold" } },
          { content: totalCash.toFixed(2), styles: { fillColor: [230,255,230], fontStyle: "bold" } }
        ],
        [
          { content: "TOTAL CARD", styles: { fillColor: [230,240,255], fontStyle: "bold" } },
          { content: totalCard.toFixed(2), styles: { fillColor: [230,240,255], fontStyle: "bold" } }
        ],
        [
          { content: "TOTAL ONLINE", styles: { fillColor: [255,245,230], fontStyle: "bold" } },
          { content: totalOnline.toFixed(2), styles: { fillColor: [255,245,230], fontStyle: "bold" } }
        ],
        [
          { content: "GRAND TOTAL (Cash + Card + Online)", styles: { fillColor: [230,230,230], fontStyle: "bold" } },
          { content: totalCollected.toFixed(2), styles: { fillColor: [230,230,230], fontStyle: "bold" } }
        ]
      ];
  
      autoTable(doc, {
        startY: afterY,
        theme: "grid",
        head: [["Payment Method", "Amount (₹)"]],
        body: paymentRows,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [100, 100, 100], textColor: 255, halign: "center", fontSize: 10 },
        columnStyles: {
          0: { cellWidth: usableWidth * 0.65, halign: "left" },
          1: { cellWidth: usableWidth * 0.35, halign: "right", fontStyle: "bold" }
        },
        tableWidth: usableWidth
      });
  
      // Footer note
      const footY = doc.lastAutoTable.finalY + 12;
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text("Note: Numbers reflect the current dashboard filters and visible rows.", marginLeft, footY);
      doc.text(`Date Range: ${rangeStr}`, marginLeft, footY + 5);
      doc.text(`Net Collection: ₹${netCollection.toFixed(2)} (Total Collected - Returns - Expenses)`, marginLeft, footY + 10);
  
      // Save file
      const filename = `accounts-summary-${now.getFullYear()}${String(now.getMonth()+1).padStart(2,"0")}${String(now.getDate()).padStart(2,"0")}_${String(now.getHours()).padStart(2,"0")}${String(now.getMinutes()).padStart(2,"0")}.pdf`;
      doc.save(filename);
    } catch (err) {
      console.error("exportSummaryWithAutoTable error:", err);
      Swal.fire({ icon: "error", title: "Export failed", text: String(err?.message || err) });
    }
  };

  const fetchLabAccounts = useCallback(async () => {
    try {
      const fd = new FormData();
      fd.append("from", `${filters.from} ${filters.fromTime}:00`);
      fd.append("to", `${filters.to} ${filters.toTime}:59`);
  
      const res = await axios.post(
        `${AppConst.BASE_URL}${AppConst.getLabAccountsSummaryUrl}`,
        fd
      );
  
      if (res?.data?.status) {
        setLabAccounts(res.data);
      } else {
        setLabAccounts(null);
      }
    } catch (e) {
      console.error("Lab accounts error", e);
      setLabAccounts(null);
    }
  }, [filters]);
  useEffect(() => {
    if (hasDept("lab")) {
      fetchLabAccounts();
    }
  }, [fetchLabAccounts, hasDept("lab")]);
   // ============================================
// FIX: Add this useEffect to sync labTotals from labAccounts
// Add this AFTER the fetchLabAccounts useEffect
// ============================================

// ✅ FIX: Sync labTotals from labAccounts
useEffect(() => {
  if (labAccounts && labAccounts.payments) {
    setLabTotals({
      total: Number(labAccounts.payments.total || 0),
      paid: Number(labAccounts.payments.total || 0), // Lab paid = total collected
      due: Number(labAccounts.total_due || 0),
      rows: Number(labAccounts.patients || labAccounts.transactions?.length || 0),
      cash: Number(labAccounts.payments.cash || 0),
      card: Number(labAccounts.payments.card || 0),
      online: Number(labAccounts.payments.online || 0),
      discount: 0
    });
    console.log("✅ Lab totals synced:", {
      total: labAccounts.payments.total,
      cash: labAccounts.payments.cash,
      card: labAccounts.payments.card,
      online: labAccounts.payments.online
    });
  } else {
    // Reset if no lab data
    setLabTotals({ total: 0, paid: 0, due: 0, rows: 0, cash: 0, card: 0, online: 0, discount: 0 });
  }
}, [labAccounts]);


// ============================================
// FULL EXPLANATION OF THE BUG:
// ============================================
// 
// BEFORE (Bug):
// - Lab card displays: labAccounts.payments.cash, labAccounts.payments.card, etc.
// - Combined Summary uses: labTotals.cash, labTotals.card, etc.
// - But labTotals was NEVER updated! Always {cash:0, card:0, online:0...}
//
// AFTER (Fix):
// - When labAccounts changes, update labTotals from it
// - Now Combined Summary shows correct lab values
// ============================================
const pharmacyReturns =
  hasDept("pharmacy") ? toNum(pharmaTotals?.returnAmount || 0) : 0;

const totalCollected =
  (combined?.cash || 0) + (combined?.card || 0) + (combined?.online || 0);


  const ipdReturnsAmount = hasDept("ipd") ? toNum(ipdReturnTotals?.total_returns || 0) : 0;
  const netCollection = totalCollected - pharmacyReturns - toNum(expensesTotals?.totalExpenses || 0);

  return (
    <div className="page-content">
      <div className="container-fluid">

        <div className="row mb-3">
          <div className="col-12">
            <h3>Accounts Dashboard</h3>
            <p className="text-muted">All accounts in one place — Lab, OPD, IPD, Pharmacy, Expenses</p>
          </div>
        </div>

        {/* Filters */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row g-2">
              <div className="col-md-2">
                <label>From (date)</label>
                <input type="date" className="form-control" name="from" value={filters.from} onChange={onFilterChange} />
              </div>
              <div className="col-md-1">
                <label>From (time)</label>
                <input type="time" className="form-control" name="fromTime" value={filters.fromTime} onChange={onFilterChange} />
              </div>
              <div className="col-md-2">
                <label>To (date)</label>
                <input type="date" className="form-control" name="to" value={filters.to} onChange={onFilterChange} />
              </div>
              <div className="col-md-1">
                <label>To (time)</label>
                <input type="time" className="form-control" name="toTime" value={filters.toTime} onChange={onFilterChange} />
              </div>

              {/* <div className="col-md-3">
                <label>User Filter</label>
                <select name="userId" className="form-select" value={filters.userId} onChange={onFilterChange}>
                  <option value="">All Users</option>
                  {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
                {usersLoading && <small className="text-muted">Loading users…</small>}
              </div> */}

              <div className="col-md-3">
                <label>Payment</label>
                <select name="paymentType" className="form-select" value={filters.paymentType} onChange={onFilterChange}>
                  <option value="All">All</option>
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="Online">Online</option>
                </select>
              </div>

              <div className="col-md-3">
  <label className="form-label">Departments</label>

  <Select
    isMulti
    closeMenuOnSelect={false}
    options={departmentOptions}
    value={departmentOptions.filter(opt =>
      selectedDepartments.includes(opt.value)
    )}
    onChange={(selected) =>
      setSelectedDepartments(selected.map(opt => opt.value))
    }
    placeholder="Select departments..."
    classNamePrefix="react-select"
  />

  <small className="text-muted">
    Choose one or more departments
  </small>
</div>


            </div>
          </div>
        </div>

        <button className="btn btn-primary ms-2 py-2 mb-3" onClick={exportSummaryWithAutoTable}>
          Export Summary PDF
        </button>

        {/* Reports row */}
        <div className="row g-3">
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          
{hasDept("lab") && labAccounts && (
  <div className="card p-3 h-100">

    <h6 className="mb-1">Lab Accounts</h6>
    <small className="text-muted">Date & time wise lab collection</small>

    {/* TOTAL COLLECTION */}
    <div className="mt-3">
      <small className="text-muted">Total Collection</small>
      <div>
        <strong style={{ fontSize: "1.5rem", color: "#198754" }}>
          ₹{labAccounts.payments.total.toFixed(2)}
        </strong>
      </div>
    </div>

    <hr />

    {/* PAYMENT BREAKDOWN */}
    <div>
      <div className="d-flex justify-content-between">
        <small>Cash</small>
        <strong>₹{labAccounts.payments.cash.toFixed(2)}</strong>
      </div>
      <div className="d-flex justify-content-between">
        <small>Card</small>
        <strong>₹{labAccounts.payments.card.toFixed(2)}</strong>
      </div>
      <div className="d-flex justify-content-between">
        <small>Online</small>
        <strong>₹{labAccounts.payments.online.toFixed(2)}</strong>
      </div>
    </div>

    {/* PATIENT INFO (ONLY IF EXISTS) */}
    {labAccounts.has_patients && (
      <>
        <hr />
        <div className="d-flex justify-content-between">
          <small>Patients</small>
          <strong>{labAccounts.patients}</strong>
        </div>
        <div className="d-flex justify-content-between">
          <small>Total Due</small>
          <strong className="text-danger">
            ₹{labAccounts.total_due.toFixed(2)}
          </strong>
        </div>
      </>
    )}

    <hr />

    {/* SHOW TRANSACTIONS */}
    <button
  className="btn btn-sm btn-outline-primary"
  onClick={() => {
    Swal.fire({
      title: "Lab Payment Transactions",
      html: `<div style="max-height:420px;overflow:auto">
        ${
          (labAccounts.transactions || []).map(t => (
            `<div style="display:flex;justify-content:space-between;margin-bottom:6px">
              <span>
                <strong>UHID:</strong>  ${t.lab_reg_uhid}<br/>
                ${new Date(t.payment_datetime).toLocaleString()}
              </span>
              <strong>₹${Number(t.payment_amount).toFixed(2)} (${t.payment_mode})</strong>
            </div>`
          )).join("")
          
          
        }
      </div>`,
      width: 700,
      confirmButtonText: "Close"
    });
  }}
>
  Show Transactions
</button>



  </div>
)}


          </div>

          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          {hasDept("opd") && (
  <AccountsReport
    title="OPD Accounts"
    apiUrl={fullUrl("getOpdListUrl")}
    method="post"
    mapping={{
      uhid: "opd_uhid",
      patient: "opd_patient_name",
      total: "opd_total",
      paid: "opd_paid",
      due: "opd_due",
      user: "user_display"
    }}
    extraSums={{
      "Total Reg Fees": "opd_reg_fees",
      "Doctor Fees": "opd_fees",
      "Procedure Bills": "procedure_bill_amount",
      "Procedure Bills Cash": "procedure_bill_cash",
      "Procedure Bills Card": "procedure_bill_card",
      "Procedure Bills Online": "procedure_bill_online"
    }}
    fetchParams={{
      page_no: "none",
      opd_user: filters.userId || undefined,
      from: `${filters.from} ${filters.fromTime}:00`,
      to: `${filters.to} ${filters.toTime}:59`
    }}
    onTotalsChange={(t) => {
      // ✅ Get procedure bill payment breakdown from extra
      const procBills = toNum(t.extra?.["Procedure Bills"] ?? 0);
      const procCash = toNum(t.extra?.["Procedure Bills Cash"] ?? 0);
      const procCard = toNum(t.extra?.["Procedure Bills Card"] ?? 0);
      const procOnline = toNum(t.extra?.["Procedure Bills Online"] ?? 0);

      // ✅ Get base OPD values
      const baseCash = toNum(t.cash);
      const baseCard = toNum(t.card);
      const baseOnline = toNum(t.online);
      const baseTotal = toNum(t.total);
      const basePaid = toNum(t.paid);

      // ✅ If base payment modes are 0 but basePaid > 0, default to cash
      let opdCash = baseCash;
      let opdCard = baseCard;
      let opdOnline = baseOnline;
      
      if (basePaid > 0 && (baseCash + baseCard + baseOnline) === 0) {
        opdCash = basePaid;
      }

      // ✅ Set OPD totals with procedure bills INCLUDED in cash/card/online
      setOpdTotals({
        total: baseTotal,  // Base OPD total (procedure bills added separately in combined)
        paid: basePaid,    // Base OPD paid
        due: toNum(t.due),
        rows: toNum(t.rows),
        cash: opdCash,     // Base OPD cash
        card: opdCard,     // Base OPD card  
        online: opdOnline, // Base OPD online
        discount: toNum(t.discount),
        opd_reg_fees: toNum(t.extra?.["Total Reg Fees"] ?? 0),
        opd_doctor_fees: toNum(t.extra?.["Doctor Fees"] ?? 0),
        // ✅ Keep procedure bill breakdown in extra for combined calculation
        extra: {
          "Total Reg Fees": toNum(t.extra?.["Total Reg Fees"] ?? 0),
          "Doctor Fees": toNum(t.extra?.["Doctor Fees"] ?? 0),
          "Procedure Bills": procBills,
          "Procedure Bills Cash": procCash,
          "Procedure Bills Card": procCard,
          "Procedure Bills Online": procOnline
        }
      });
    }}
    compact
    collectApi="Webapis/collect_account"
    currentUserId={logged?.id}
    currentUserName={logged?.name}
  />
)}
</div>


          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          {hasDept("ipd") && (
            <AccountsReport
              title="IPD Admitted Accounts"
              apiUrl={fullUrl("getIpdListUrl3")}
              method="post"
              mapping={{ uhid: "ipd_uhid", patient: "ipd_patient_name", total: "ipd_total_paid", paid: "ipd_total_paid", due: "ipd_due", user: "user_display" }}
              fetchParams={{ ...baseFetchParams }}
              onTotalsChange={handleIpdAdmitted}
              compact={true}
              collectApi="Webapis/collect_account"
              currentUserId={logged?.id}
              currentUserName={logged?.name}
            />
          )}
          </div>

          {hasDept("ipd") && (
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
  <div className="card p-3 h-100">
  
    <h6 className="mb-1">IPD Advance Payments</h6>
    <small className="text-muted">Date & time wise advance collection</small>

    <div className="mt-3">
      <small className="text-muted">Total Advance Collected</small>
      <div>
        <strong style={{ fontSize: '1.4rem', color: '#198754' }}>
          ₹{ipdAdvanceTotals.total.toFixed(2)}
        </strong>
      </div>
    </div>

    <div className="mt-2">
      <small className="text-muted">No. of Payments</small>
      <div><strong>{ipdAdvanceTotals.rows}</strong></div>
    </div>

    <hr />

    {/* Quick preview – last 3 payments */}
    {ipdAdvanceTotals.records.slice(0, 3).map((p, i) => (
      <div key={i} className="d-flex justify-content-between small mb-1">
        <span>
          {new Date(p.payment_date).toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit'
          })}
        </span>
        <strong>₹{Number(p.advance_amount).toFixed(2)}</strong>
      </div>
    ))}

    {ipdAdvanceTotals.rows > 3 && (
      <small className="text-primary mt-1 d-block">
        + {ipdAdvanceTotals.rows - 3} more payments
      </small>
    )}

    {/* Optional: open existing modal */}
    <button
      className="btn btn-sm btn-outline-primary mt-2"
      onClick={() => {
        Swal.fire({
          title: 'IPD Advance Payment History',
          html: `<div style="max-height:400px;overflow:auto">
            ${ipdAdvanceTotals.records.map(p => `
              <div style="display:flex;justify-content:space-between;margin-bottom:6px">
                <span>${new Date(p.payment_date).toLocaleString()}</span>
                <strong>₹${Number(p.advance_amount).toFixed(2)}</strong>
              </div>
            `).join('')}
          </div>`,
          width: 600,
          confirmButtonText: 'Close'
        });
      }}
    >
      View History
    </button>

    <div className="mt-2">
  <div className="d-flex justify-content-between">
    <small>Cash</small>
    <strong>₹{ipdAdvanceTotals.cash.toFixed(2)}</strong>
  </div>
  <div className="d-flex justify-content-between">
    <small>Card</small>
    <strong>₹{ipdAdvanceTotals.card.toFixed(2)}</strong>
  </div>
  <div className="d-flex justify-content-between">
    <small>Online</small>
    <strong>₹{ipdAdvanceTotals.online.toFixed(2)}</strong>
  </div>
</div>

  </div>
</div>
)}
         
<div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
  {hasDept("ipd") && (
    <div className="card p-3 h-100">
    <h6>IPD Discharge Accounts</h6>
    <small className="text-muted">Payment transactions</small>
  
    <div className="mt-3">
      <small>Total Paid</small>
      <div>
        <strong style={{ fontSize: "1.4rem", color: "#198754" }}>
        ₹{(ipdDischargeTotals.sum_paid ?? 0).toFixed(2)}
        </strong>
      </div>
    </div>
  
    <hr />
  
    <div className="d-flex justify-content-between">
      <small>Cash</small>
      <strong>₹{(ipdDischargeTotals.cash ?? 0).toFixed(2)}</strong>
    </div>
    <div className="d-flex justify-content-between">
      <small>Card</small>
      <strong>₹{(ipdDischargeTotals.card ?? 0).toFixed(2)}</strong>
    </div>
    <div className="d-flex justify-content-between">
      <small>Online</small>
      <strong>₹{(ipdDischargeTotals.online ?? 0).toFixed(2)}</strong>
    </div>
  
    <hr />
  
    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => {
        Swal.fire({
          title: "IPD Discharge Payment Transactions",
          width: 1000,
          html: `
            <div style="max-height:450px;overflow:auto">
              <table style="width:100%;border-collapse:collapse">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Patient</th>
                    <th>Mode</th>
                    <th>Total</th>
                    <th>Cash</th>
                    <th>Card</th>
                    <th>Online</th>
                    <th>Received By</th>
                  </tr>
                </thead>
                <tbody>
                  ${ipdDischargeTransactions.map(t => `
                    <tr>
                      <td>${new Date(t.payment_datetime).toLocaleString('en-IN')}</td>
                      <td>${t.patient_name}</td>
                      <td>${t.payment_mode}</td>
                      <td>₹${Number(t.payment_amount).toFixed(2)}</td>
                      <td>₹${Number(t.cash).toFixed(2)}</td>
                      <td>₹${Number(t.card).toFixed(2)}</td>
                      <td>₹${Number(t.online).toFixed(2)}</td>
                      <td>${t.received_by_name}</td>
                    </tr>
                  `).join("")}
                </tbody>
              </table>
            </div>
          `,
          confirmButtonText: "Close"
        });
      }}
    >
      Show Transactions ({ipdDischargeTransactions.length})
    </button>
  </div>
  
  )}
</div>

{hasDept("pharmacy") && (
  <div className="col-xl-6 col-lg-12 col-md-12">
    <div className="card p-3 h-100">
      <h6 className="mb-1">Pharmacy Accounts</h6>
      <small className="text-muted">Date-wise payment collection & returns</small>

      {pharmacyPaymentLoading ? (
        <div className="text-muted mt-3">Loading...</div>
      ) : (
        <>
          {/* ✅ TOTAL COLLECTION */}
          <div className="mt-3">
            <small className="text-muted">Total Collection</small>
            <div>
              <strong style={{ fontSize: '1.5rem', color: '#198754' }}>
                ₹{pharmacyPaymentHistory.totals.total_amount.toFixed(2)}
              </strong>
            </div>
            <small className="text-muted">
              ({pharmacyPaymentHistory.totals.payment_count} payments)
            </small>
          </div>

          <hr />

          {/* ✅ PAYMENT BREAKDOWN */}
          <div>
            <div className="d-flex justify-content-between mb-2">
              <small>Cash</small>
              <strong>₹{pharmacyPaymentHistory.totals.total_cash.toFixed(2)}</strong>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <small>Card</small>
              <strong>₹{pharmacyPaymentHistory.totals.total_card.toFixed(2)}</strong>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <small>Online</small>
              <strong>₹{pharmacyPaymentHistory.totals.total_online.toFixed(2)}</strong>
            </div>
           
          </div>

          {/* ✅ RETURNS & FINAL COLLECTION */}
          {pharmacyPaymentHistory.totals.total_returns > 0 && (
            <>
              <hr />
              <div className="d-flex justify-content-between mb-2">
                <small className="text-danger">Return Amount</small>
                <strong className="text-danger">
                  - ₹{pharmacyPaymentHistory.totals.total_returns.toFixed(2)}
                </strong>
              </div>
            </>
          )}

          <hr />
          <div className="d-flex justify-content-between mb-2">
            <small className="text-success">
              <strong>Final Collection</strong>
            </small>
            <strong className="text-success" style={{ fontSize: '1.2rem' }}>
              ₹{pharmacyPaymentHistory.totals.final_collection.toFixed(2)}
            </strong>
          </div>

          <hr />

          {/* ✅ DAILY BREAKDOWN */}
          <div>
            <small className="text-muted">Daily Breakdown</small>
            <div style={{ maxHeight: '200px', overflowY: 'auto' }} className="mt-2">
              {pharmacyPaymentHistory.daily_breakdown.length > 0 ? (
                pharmacyPaymentHistory.daily_breakdown.map((day, idx) => (
                  <div 
                    key={idx} 
                    className="p-2 mb-2" 
                    style={{ backgroundColor: '#f8f9fa', borderRadius: '4px' }}
                  >
                    <div className="d-flex justify-content-between">
                      <strong>
                        {new Date(day.date).toLocaleDateString('en-IN', { 
                          day: '2-digit', 
                          month: 'short', 
                          year: 'numeric' 
                        })}
                      </strong>
                      <strong className="text-success">₹{day.total.toFixed(2)}</strong>
                    </div>
                    <div className="d-flex justify-content-between mt-1">
                      <small className="text-muted">
                        {day.count} payments | {day.patients} patients
                      </small>
                      <small>
                        C: ₹{day.cash.toFixed(0)} | 
                        Ca: ₹{day.card.toFixed(0)} | 
                        O: ₹{day.online.toFixed(0)}
                      </small>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-muted text-center py-3">
                  No payments in this period
                </div>
              )}
            </div>
          </div>

          {/* ✅ VIEW TRANSACTIONS BUTTON */}
          <button
            className="btn btn-sm btn-outline-primary mt-3"
            onClick={() => {
              Swal.fire({
                title: 'Pharmacy Payment Transactions',
                html: `
                  <div style="max-height:500px;overflow:auto">
                    <table style="width:100%;border-collapse:collapse">
                      <thead style="position:sticky;top:0;background:#f8f9fa">
                        <tr>
                          <th style="padding:8px;border-bottom:2px solid #dee2e6;text-align:left">Date & Time</th>
                          <th style="padding:8px;border-bottom:2px solid #dee2e6;text-align:left">Patient</th>
                          <th style="padding:8px;border-bottom:2px solid #dee2e6;text-align:left">Mode</th>
                          <th style="padding:8px;border-bottom:2px solid #dee2e6;text-align:right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${pharmacyPaymentHistory.payments.map(t => `
                          <tr>
                            <td style="padding:8px;border-bottom:1px solid #dee2e6">
                              ${new Date(t.payment_datetime).toLocaleString('en-IN')}
                            </td>
                            <td style="padding:8px;border-bottom:1px solid #dee2e6">
                              ${t.med_bill_patient_number || 'N/A'}<br/>
                              <small style="color:#6c757d">UHID: ${t.med_bill_ipd_number || 'N/A'}</small>
                            </td>
                            <td style="padding:8px;border-bottom:1px solid #dee2e6">
                              <span style="padding:2px 8px;border-radius:4px;font-size:12px;background:${
                                t.payment_mode === 'Cash' ? '#d4edda' : 
                                t.payment_mode === 'Card' ? '#d1ecf1' : '#fff3cd'
                              }">${t.payment_mode}</span>
                            </td>
                            <td style="padding:8px;border-bottom:1px solid #dee2e6;text-align:right">
                              <strong>₹${Number(t.payment_amount).toFixed(2)}</strong>
                            </td>
                          </tr>
                        `).join('')}
                      </tbody>
                    </table>
                  </div>
                `,
                width: 900,
                confirmButtonText: 'Close'
              });
            }}
          >
            View All Transactions ({pharmacyPaymentHistory.totals.payment_count})
          </button>
        </>
      )}
    </div>
  </div>
)}

          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          {hasDept("emergency") && (
  <AccountsReport
    title="Emergency / DayCare Accounts"
    apiUrl={fullUrl("getEmergencyListUrl")}
    method="post"
    mapping={{
      uhid: "ipd_uhid",
      patient: "ipd_patient_name",
      total: "total_amount",
      paid: "paid_amount",
      due: "ipd_due",
      user: "user_display"
    }}
    extraSums={{
      "Reg Charges": "ipd_paid",
      "Reg Cash": "ipd_paid_cash",
      "Reg Card": "ipd_paid_card",
      "Reg Online": "ipd_paid_online",
      "Procedure Bills": "procedure_bill_amount",
      "Procedure Bills Cash": "procedure_bill_cash",
      "Procedure Bills Card": "procedure_bill_card",
      "Procedure Bills Online": "procedure_bill_online"
    }}
    fetchParams={{
      page_no: "none",
      from: `${filters.from} ${filters.fromTime}:00`,
      to: `${filters.to} ${filters.toTime}:59`,
      ipd_user: filters.userId || undefined
    }}
    onTotalsChange={(t) => {
      const reg = toNum(t.extra?.["Reg Charges"] || 0);
      const proc = toNum(t.extra?.["Procedure Bills"] || 0);
      const paid = reg + proc;

      const regCash = toNum(t.extra?.["Reg Cash"] || 0);
      const regCard = toNum(t.extra?.["Reg Card"] || 0);
      const regOnline = toNum(t.extra?.["Reg Online"] || 0);
      const procCash = toNum(t.extra?.["Procedure Bills Cash"] || 0);
      const procCard = toNum(t.extra?.["Procedure Bills Card"] || 0);
      const procOnline = toNum(t.extra?.["Procedure Bills Online"] || 0);

      setEmergencyTotals({
        ...t,
        total: paid,
        paid: paid,
        due: 0,
        cash: regCash + procCash,
        card: regCard + procCard,
        online: regOnline + procOnline,
        extra: t.extra
      });
    }}
    compact
    // ✅ Override the card's payment breakdown with correct values
    overridePaymentBreakdown={{
      cash: toNum(emergencyTotals.cash),
      card: toNum(emergencyTotals.card),
      online: toNum(emergencyTotals.online)
    }}
    collectApi="Webapis/collect_account"
    currentUserId={logged?.id}
    currentUserName={logged?.name}
  />
)}


</div>



{hasDept("ipd") && (
  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
    <div className="card p-3 h-100">
      <h6 className="mb-1">IPD Returns / Refunds</h6>
      <small className="text-muted">Advance excess returned to patients</small>
 
      {ipdReturnLoading ? (
        <div className="text-muted mt-3">Loading...</div>
      ) : (
        <>
          {/* Total Returns */}
          <div className="mt-3">
            <small className="text-muted">Total Returns</small>
            <div>
              <strong style={{ fontSize: '1.4rem', color: '#dc3545' }}>
                ₹{toNum(ipdReturnTotals.total_returns).toFixed(2)}
              </strong>
            </div>
            <small className="text-muted">
              ({ipdReturnTotals.return_count} returns)
            </small>
          </div>
 
          <hr />
 
          {/* Return Mode Breakdown */}
          <div>
            <div className="d-flex justify-content-between mb-1">
              <small>Cash Returns</small>
              <strong>₹{toNum(ipdReturnTotals.total_cash).toFixed(2)}</strong>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <small>Card Refunds</small>
              <strong>₹{toNum(ipdReturnTotals.total_card).toFixed(2)}</strong>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <small>Online/Bank Transfer</small>
              <strong>₹{toNum(ipdReturnTotals.total_online).toFixed(2)}</strong>
            </div>
          </div>
 
          <hr />
 
          {/* Lab/Pharmacy paid from advance */}
          <div>
            <div className="d-flex justify-content-between mb-1">
              <small>Lab Paid from Advance</small>
              <strong className="text-info">₹{toNum(ipdReturnTotals.total_lab_paid).toFixed(2)}</strong>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <small>Pharmacy Paid from Advance</small>
              <strong className="text-info">₹{toNum(ipdReturnTotals.total_pharmacy_paid).toFixed(2)}</strong>
            </div>
          </div>
 
          {/* View Details Button */}
          {ipdReturnTotals.records && ipdReturnTotals.records.length > 0 && (
            <button
              className="btn btn-sm btn-outline-danger mt-2"
              onClick={() => {
                Swal.fire({
                  title: 'IPD Return / Refund History',
                  width: 900,
                  html: `
                    <div style="max-height:450px;overflow:auto">
                      <table style="width:100%;border-collapse:collapse;font-size:13px">
                        <thead style="position:sticky;top:0;background:#f8f9fa">
                          <tr>
                            <th style="padding:8px;border-bottom:2px solid #dee2e6">Date</th>
                            <th style="padding:8px;border-bottom:2px solid #dee2e6">Patient</th>
                            <th style="padding:8px;border-bottom:2px solid #dee2e6">UHID</th>
                            <th style="padding:8px;border-bottom:2px solid #dee2e6;text-align:right">Return Amt</th>
                            <th style="padding:8px;border-bottom:2px solid #dee2e6">Mode</th>
                            <th style="padding:8px;border-bottom:2px solid #dee2e6;text-align:right">Lab Paid</th>
                            <th style="padding:8px;border-bottom:2px solid #dee2e6">Processed By</th>
                          </tr>
                        </thead>
                        <tbody>
                          ${ipdReturnTotals.records.map(r => `
                            <tr>
                              <td style="padding:6px;border-bottom:1px solid #eee">${new Date(r.return_datetime).toLocaleString('en-IN')}</td>
                              <td style="padding:6px;border-bottom:1px solid #eee">${r.patient_name || 'N/A'}</td>
                              <td style="padding:6px;border-bottom:1px solid #eee">${r.return_uhid}</td>
                              <td style="padding:6px;border-bottom:1px solid #eee;text-align:right;color:#dc3545;font-weight:bold">₹${Number(r.return_amount).toFixed(2)}</td>
                              <td style="padding:6px;border-bottom:1px solid #eee">${r.return_mode}</td>
                              <td style="padding:6px;border-bottom:1px solid #eee;text-align:right">₹${Number(r.lab_paid_from_advance || 0).toFixed(2)}</td>
                              <td style="padding:6px;border-bottom:1px solid #eee">${r.processed_by_name || 'N/A'}</td>
                            </tr>
                          `).join('')}
                        </tbody>
                      </table>
                    </div>
                  `,
                  confirmButtonText: 'Close'
                });
              }}
            >
              View All Returns ({ipdReturnTotals.return_count})
            </button>
          )}
        </>
      )}
    </div>
  </div>
)}



          {hasDept("ipd") && (
          <div className="col-lg-6 col-md-12">
          <div className="card p-3">
  <h6 className="mb-2">IPD Summary</h6>

  <div className="row g-2">
    <div className="col-12">
    <small className="text-muted">IPD Advance Collected</small>
    <div>
<strong>
  ₹{ipdAdvanceCollected.toLocaleString(undefined, { minimumFractionDigits: 2 })}
</strong>
</div>
    </div>

    <div className="col-12 mt-2">
      <small className="text-muted">IPD Bill Paid</small>
      <div>
        <strong>
          ₹{ipdBillPaid.toLocaleString(undefined, { minimumFractionDigits: 2 })}
        </strong>
      </div>
    </div>

    <div className="col-12 mt-3">
      <small className="text-muted">TOTAL PAID (Reg + Advance + Bill)</small>
      <div>
        <strong style={{ fontSize: '1.25rem' }}>
          ₹{(regPlusAdvance + ipdBillPaid).toLocaleString(undefined, { minimumFractionDigits: 2 })}
        </strong>
      </div>
    </div>

    <div className="col-6 mt-3">
      <small className="text-muted">IPD Bill Due</small>
      <div>
        <strong>
          ₹{(ipdTotals.sum_due || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
        </strong>
      </div>
    </div>
  </div>
</div>

          </div>
          )}
        </div>
          
        {/* Combined Summary */}
       {/* Combined Summary */}
<div className="row mt-4">
  <div className="col-12">
    <div className="card p-3">
      <h5>Combined Summary</h5>
      <div className="d-flex flex-wrap gap-3">
        <div><small className="text-muted">Total Amount</small><div><strong> ₹{(combined.paid + combined.due).toFixed(2)}</strong></div></div>
        <div><small className="text-muted">Paid</small><div><strong>₹{combined.paid.toFixed(2)}</strong></div></div>
        <div><small className="text-muted">Due</small><div><strong>₹{combined.due.toFixed(2)}</strong></div></div>
        <div><small className="text-muted">Total Patient</small><div><strong>{combined.rows}</strong></div></div>
      </div>
      <hr />
      <div className="d-flex flex-wrap gap-3">
        <div><small className="text-muted">Cash Paid</small><div><strong>₹{combined.cash.toFixed(2)}</strong></div></div>
        <div><small className="text-muted">Card Paid</small><div><strong>₹{combined.card.toFixed(2)}</strong></div></div>
        <div><small className="text-muted">Online Paid</small><div><strong>₹{combined.online.toFixed(2)}</strong></div></div>
      </div>
      
      {/* ✅ Show Pharmacy Return if exists */}
      {hasDept("pharmacy") && pharmaTotals.returnAmount > 0 && (
        <>
          <hr />
          <div className="d-flex flex-wrap gap-3">
            <div>
              <small className="text-danger">Pharmacy Returns</small>
              <div><strong className="text-danger">₹{pharmaTotals.returnAmount.toFixed(2)}</strong></div>
            </div>
            <div>
              <small className="text-muted">Note: Returns already deducted from payment totals above</small>
            </div>
          </div>
        </>
      )}



{hasDept("ipd") && toNum(ipdReturnTotals.total_returns) > 0 && (
  <>
    <hr />
    <div className="d-flex flex-wrap gap-3">
      <div>
        <small className="text-danger">IPD Returns / Refunds</small>
        <div><strong className="text-danger">₹{toNum(ipdReturnTotals.total_returns).toFixed(2)}</strong></div>
      </div>
      <div>
        <small className="text-info">Lab Paid from Advance</small>
        <div><strong className="text-info">₹{toNum(ipdReturnTotals.total_lab_paid).toFixed(2)}</strong></div>
      </div>
      <div>
        <small className="text-info">Pharmacy Paid from Advance</small>
        <div><strong className="text-info">₹{toNum(ipdReturnTotals.total_pharmacy_paid).toFixed(2)}</strong></div>
      </div>
    </div>
  </>
)}
    </div>
  </div>
</div>

        {/* ✅ Expenses Section */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="card p-3">
              <h5>Expenses</h5>
              {expensesLoading ? (
                <div className="text-muted">Loading expenses...</div>
              ) : (
                <>
                  <div className="d-flex flex-wrap gap-3 mb-3">
                    <div>
                      <small className="text-muted">Total Expenses</small>
                      <div><strong className="text-danger" style={{ fontSize: '1.3rem' }}>₹{(expensesTotals?.totalExpenses || 0).toFixed(2)}</strong></div>
                    </div>
                    <div>
                      <small className="text-muted">Expense Count</small>
                      <div><strong>{expensesTotals?.expensesCount || 0}</strong></div>
                    </div>
                  </div>

                  {/* ✅ Total Collection = Paid - Expenses */}
                  <hr />
                  <div className="d-flex flex-wrap gap-3">
                    <div>
                      <small className="text-muted">Total Paid (Revenue Collected)</small>
                      <div><strong style={{ fontSize: '1.1rem' }}>₹{combined.paid.toFixed(2)}</strong></div>
                    </div>
                    <div>
                      <small className="text-muted">Total Expenses</small>
                      <div><strong className="text-danger" style={{ fontSize: '1.1rem' }}>- ₹{(expensesTotals?.totalExpenses || 0).toFixed(2)}</strong></div>
                    </div>
                  </div>

                  <div className="mt-3 p-3" style={{ backgroundColor: '#e8f5e9', borderRadius: '8px' }}>
                    <small className="text-success">Total Collection (Paid Amount - Expenses)</small>
                    <div>

                      
                   <strong className="text-success" style={{ fontSize: '1.5rem' }}>
  ₹{(netCollection || 0).toFixed(2)}
</strong>

                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}